import { put, call } from "redux-saga/effects";
import { DocumentCaseAPI } from "../../utils/api/DocumentCaseAPI";
import { SAVE_DOCUMENTCASE_SUCCESS,SAVE_DOCUMENTCASE_FAILED ,
    UPDATE_DOCUMENTCASE_SUCCESS,UPDATE_DOCUMENTCASE_FAILED ,
    GET_ALLDOCUMENTCASE_SUCCESS,GET_ALLDOCUMENTCASE_FAILED ,
    GET_ALLDOCUMENTCASE_BYID_SUCCESS,GET_ALLDOCUMENTCASE_BYID_FAILED,
    GET_ALLDOCUMENTCASE_BYUSER_SUCCESS,GET_ALLDOCUMENTCASE_BYUSER_FAILED } from "../actions/DocumentCase";

export function* documentCaseCreate(request: any) {
 
      try {
             const result=yield call(DocumentCaseAPI.documentCaseCreate, request.input);
           yield put({ 
              type: SAVE_DOCUMENTCASE_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_DOCUMENTCASE_FAILED, payload: e.message });
      }
  }

  export function* documentCaseUpdate(request: any) {
  
      try {
             const result=yield call(DocumentCaseAPI.documentCaseUpdate, request.input);
           yield put({ 
              type: UPDATE_DOCUMENTCASE_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_DOCUMENTCASE_FAILED, payload: e.message });
      }
  }
  export function*getAllDocumentCaseflows (request:any) {
    try {
      
        const { data } = yield call(DocumentCaseAPI.getAllDocumentCaseflows,request);
   
      
      yield put({
          type: GET_ALLDOCUMENTCASE_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ALLDOCUMENTCASE_FAILED, payload: e.message });
    }
}

export function*getAllDocumentCaseflowsById (request:any) {
    try {
      
        const { data } = yield call(DocumentCaseAPI.getAllDocumentCaseflowsById,request);
   
      
      yield put({
          type: GET_ALLDOCUMENTCASE_BYID_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ALLDOCUMENTCASE_BYID_FAILED, payload: e.message });
    }
}

export function*getAllDocumentCaseflowsByUserId (request:any) {
    try {
      
        const { data } = yield call(DocumentCaseAPI.getAllDocumentCaseflowsByUserId,request);
   
      
      yield put({
          type: GET_ALLDOCUMENTCASE_BYUSER_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ALLDOCUMENTCASE_BYUSER_FAILED, payload: e.message });
    }
}